import script from "./Divider.vue?vue&type=script&setup=true&lang=js"
export * from "./Divider.vue?vue&type=script&setup=true&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=178bf80e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178bf80e"]])

export default __exports__